export const strings = [
  {
    name: 'ucFirst',
    description: [
      'This method returns string with first character upper cased',
      'Usage:',
      'str.ucFirst(string)',
      'example: you pass => "john doe" , you get => "John doe" ',
    ],
  },
  {
    name: 'wcUpper',
    description: [
      'This method returns string with character upper cased for every word',
      'Usage:',
      'str.wcUpper(string)',
      'example: you pass => "john doe" , you get => "John Doe" ',
    ],
  },
  {
    name: 'rstring',
    description: [
      'This method returns takes a string and returns a reversed string',
      'Usage:',
      'str.rstring(string)',
      'example: you pass => "john doe" , you get => "eoD nhoJ" ',
    ],
  },
  {
    name: 'upper',
    description: [
      'This method returns uppercased string',
      'Usage:',
      'str.upper(string)',
      'example: you pass => "john doe" , you get => "JOHN DOE" ',
    ],
  },
]
